module.exports = __webpack_public_path__ + "static/p-logo--subscstore-5b23b07ae86e382fa967866286838572.png";